export const env = {
  NODE_ENV: process.env.NODE_ENV,
  TRACKJS_TOKEN: process.env.GATSBY_APP_TRACKJS_TOKEN,
} as const
